import RestRepository from '@candybox/repository/rest.js';
import Employee from '@app/employee/documents/service-employee.js';
import employeesMap from '@app/employee/requests/service-employee-repository.js';
import { singleton } from '@candybox/helpers.js';

export default singleton(() => {
    return new RestRepository(Employee, employeesMap());
});
